import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";

const Blogdetails = () => {
  return (
    <>
      <div className="blog-detail-main w-full bg-white">
        <img
          src="../../../../../assets/images/blogs/blog-detail.png"
          alt=""
          className="max-sm:h-[250px] "
        />
        <div className="detail-inner max-xxxl:max-w-[90%] max-w-[60%] m-auto pt-[61px] pb-[109px]">
          {/* profile */}
          <div className="profile flex items-center gap-2">
            <img
              src="../../../../../assets/images/blogs/profile.png"
              alt=""
              className="w-[60px] h-[60px] rounded-full"
            />
            <div className="flex flex-col">
              <h5 className="small text-[#592EA9] font-bold">Andrew Jonson</h5>
              <p className="small text-[#6D6E76]">
                Posted on 27th January 2022
              </p>
            </div>
          </div>
          {/* content details */}
          <div className="flex flex-col mt-9">
            <h4 className="font-bold max-w-[668px]">
              Step-by-step guide to choosing great font pairs
            </h4>
            <div className="flex gap-2 items-center mt-2">
              <Icon
                icon="vscode-icons:file-type-shuttle"
                width="24"
                height="24"
              />
              <p className="font-bold">Startup</p>
            </div>
            <div className="flex flex-col gap-[20px] mt-[66px]">
              <h5 className=" font-bold max-w-[920px]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod.
              </h5>
              <p className="max-w-[1320px] large leading-[28px] text-[#6D6E76]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Non
                blandit massa enim nec. Scelerisque viverra mauris in aliquam
                sem. At risus viverra adipiscing at in tellus. Sociis natoque
                penatibus et magnis dis parturient montes. Ridiculus mus mauris
                vitae ultricies leo. Neque egestas congue quisque egestas diam.
                Risus in hendrerit gravida rutrum quisque non.
              </p>
            </div>
            <div className="flex flex-col gap-[20px] mt-[66px]">
              <h5 className=" font-bold max-w-[920px]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod.
              </h5>
              <p className="max-w-[1320px] large leading-[28px] text-[#6D6E76]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Non
                blandit massa enim nec. Scelerisque viverra mauris in aliquam
                sem. At risus viverra adipiscing at in tellus. Sociis natoque
                penatibus et magnis dis parturient montes. Ridiculus mus mauris
                vitae ultricies leo. Neque egestas congue quisque egestas diam.
                Risus in hendrerit gravida rutrum quisque non.
                <br />
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Non
                blandit massa enim nec. Scelerisque viverra mauris in aliquam
                sem. At risus viverra adipiscing at in tellus. Sociis natoque
                penatibus et magnis dis parturient montes. Ridiculus mus mauris
                vitae ultricies leo. Neque egestas congue quisque egestas diam.
                Risus in hendrerit gravida rutrum quisque non.
              </p>
              <ul className="list-disc pl-5 font-bold space-y-3">
                <li>Lorem ipsum dolor sit amet</li>
                <li>Non blandit massa enim nec scelerisque</li>
                <li>Neque egestas congue quisque egestas</li>
              </ul>
              <p className="max-w-[1320px] large leading-[28px] text-[#6D6E76]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Non
                blandit massa enim nec. Scelerisque viverra mauris in aliquam
                sem. At risus viverra adipiscing at in tellus. Sociis natoque
                penatibus et magnis dis parturient montes. Ridiculus mus mauris
                vitae ultricies leo. Neque egestas congue quisque egestas diam.
                Risus in hendrerit gravida rutrum quisque non.
              </p>
            </div>
            <div className="flex flex-col gap-[20px] mt-[66px]">
              <h5 className=" font-bold max-w-[920px]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod.
              </h5>
              <p className="max-w-[1320px] large leading-[28px] text-[#6D6E76]">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Non
                blandit massa enim nec. Scelerisque viverra mauris in aliquam
                sem. At risus viverra adipiscing at in tellus. Sociis natoque
                penatibus et magnis dis parturient montes. Ridiculus mus mauris
                vitae ultricies leo. Neque egestas congue quisque egestas diam.
                Risus in hendrerit gravida rutrum quisque non.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Blogdetails;
